<template>
    <header id="main-navigation">
        <!-- main logo -->
        <aside id="header-logo">
            <router-link to="/" exact>
                <img src="/img/nutron-logo.png" alt="nutron-logo" class="img-fluid"/>
            </router-link>
            <div class="authorized-reseller">
                <img
                        src="/img/authorized-service-provider.png"
                        class="img-fluid"
                        alt="apple authorized service provider"
                />
            </div>
        </aside>
        <!-- ./ main logo -->
        <!-- main main -->
        <section id="main-menu">
            <ul class="menu-list">
                <li v-for="menu in base_menus" :key="menu.path">
                    <router-link :to="{ name: menu.path }" exact>{{ menu.label }}</router-link>
                </li>
                <li v-if="getAuthenticatedUser" class="user-dropdown hidden-sm-and-down">
                    <el-dropdown>
              <span class="el-dropdown-link user-name">
                {{ this.getAuthenticatedUser.name }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                        <el-dropdown-menu class="user-dropdown-menu">
                            <el-dropdown-item>
                                <router-link :to="{ name: 'profile' }" class="dropdown-item">Profile</router-link>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <router-link
                                        :to="{ name: 'update-password' }"
                                        class="dropdown-item"
                                >Update Password
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <router-link :to="{ name: 'my-orders' }" class="dropdown-item">My Orders</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <el-link
                                        @click="logout"
                                        v-loading.fullscreen.lock="loading"
                                        :underline="false"
                                >Logout
                                </el-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
                <li class="hidden-sm-and-down" v-else>
                    <router-link :to="{ name: 'signin' }">login</router-link>
                </li>
            </ul>
        </section>
        <!-- ./ main menu -->
        <aside id="right-side">
            <ul class="card-icons-list">
                <li>
                    <search-component/>
                </li>
            </ul>
            <router-link class="cart" :to="{name: 'cart' }">
                <img src="/img/icons/bag.svg" alt="icon" class="img-fluid"/>
                <sup class="cart-count" v-if="getCart && getCart.length">{{ getCart.length }}</sup>
            </router-link>
        </aside>
        <aside id="mobile-menu">
            <el-button type="text" class="burger" @click="toggleMenu">
                <span></span>
                <span></span>
                <span></span>
            </el-button>
            <Slide
                    disableOutsideClick
                    noOverlay
                    :isOpen="isNavOpen"
                    @openMenu="isNavOpen = true"
                    @closeMenu="isNavOpen = false"
            >
                <div class="mobile-side-menu">
                    <user-drop-down-mobile/>
                    <ul class="menu-list">
                        <li v-for="menu in base_menus" :key="menu.path">
                            <router-link :to="{ name: menu.path }" exact>{{ menu.label }}</router-link>
                        </li>
                    </ul>
                    <easy-access-navbar-mobile/>
                </div>
            </Slide>
        </aside>
    </header>
</template>

<script>
    import {mapGetters} from "vuex";
    import SearchComponent from "../SearchComponent";
    import {Slide} from "vue-burger-menu";
    import EasyAccessNavbarMobile from "@/components/EasyAccessNavbarMobile";
    import UserDropDownMobile from "../shared/UserDropDownMobile";

    export default {
        name: "MainNavigation",
        data() {
            return {
                allowed: false,
                isNavOpen: false,
                loading: false,
                base_menus: [
                    {
                        label: 'About us',
                        path: 'about'
                    },
                    {
                        label: 'Our Services',
                        path: 'our-services'
                    },
                    {
                        label: 'Faq',
                        path: 'faqs'
                    },
                    {
                        label: 'Contact us',
                        path: 'contact'
                    }
                ]
            };
        },
        components: {SearchComponent, Slide, EasyAccessNavbarMobile, UserDropDownMobile},
        computed: {
            ...mapGetters('auth', ['getAuthenticatedUser']),
            ...mapGetters('cart', ['getCart']),
        },
        created() {
            this.$root.$on("closenav", status => {
                this.isNavOpen = status;
            });
        },
        methods: {
            async logout() {
                this.loading = true;
                await this.$store.dispatch("auth/sign_out");
                if (!this.getAuthenticationStatus) {
                    await this.$router.push({name: "home"});
                }
            },
            toggleMenu() {
                this.isNavOpen = !this.isNavOpen
            }
        }
    }
</script>

<style lang="scss">
    $min_width: 1194px;
    #main-navigation {
        display: grid;
        @media all and (min-width: $min_width) {
            grid-template-columns: 300px 3fr 350px;
            margin-bottom: 10px;
        }
        @media all and (max-width: $min_width) {
            grid-template-columns: 300px 3fr 70px;
        }
        @media all and (max-width: 768px) {
            grid-template-columns: 200px 3fr 50px;
            padding: 0 5px;
        }
        padding: 0 20px;

        #header-logo {
            display: grid;
            grid-template-columns: 1fr 130px;
            grid-gap: 20px;
            justify-content: space-between;
            align-items: center;
            @media all and (max-width: 768px) {
                grid-gap: 0;
                grid-template-columns: 1fr;
                align-items: center;
                img {
                    width: 80%;
                }
                .authorized-reseller {
                    width: 50%;
                }
            }
            @media all and (min-width: 768px) {
                .authorized-reseller {
                    width: 80%;
                }

                img {
                    width: 100%;
                }
            }
        }

        #main-menu {
            display: flex;
            justify-content: center;
            align-items: center;
            @media all and (max-width: $min_width) {
                display: none;
            }

            ul {
                list-style: none;

                li {
                    display: inline-block;
                    margin: 0 5px;

                    a {
                        color: #000;
                        text-transform: uppercase;
                        font-size: 1rem;
                    }
                }
            }
        }

        #right-side {
            display: grid;
            grid-template-columns: 1fr 50px;
            grid-gap: 5px;
            align-items: center;

            .cart {
                img {
                    width: 50%;
                }

                .cart-count {
                    font-size: 1rem;
                    font-weight: bold;
                    color: #11233f;
                    margin: 5px
                }
            }
        }

        #mobile-menu {
            position: relative;
            @media all and (min-width: $min_width) {
                display: none;
            }
            @media all and (max-width: $min_width) {
                display: grid;
                align-items: center;
                justify-content: end;
            }
            .burger {
                cursor: pointer;
                padding: 0;
                position: relative;
                width: 40px;
                height: 40px;
                span {
                    display: block;
                    position: relative;
                    height: 35px;
                    span {
                        position: absolute;
                        height: 2px;
                        right: 0;
                        width: 40px;
                        background: #11233f;
                        &:nth-child(1) {
                            top: 25%;
                        }
                        &:nth-child(2) {
                            top: 50%;
                        }
                        &:nth-child(3) {
                            top: 75%;
                        }
                    }
                }
            }

            .bm-menu {
                background: #fff;
                z-index: 91000;
                box-shadow: 0 0 2px rgba(0, 0, 0, .45);
                .mobile-side-menu {
                    background: #fff;
                    display: grid;
                    grid-template-columns: 1fr;
                    font-size: 1rem;
                    .menu-list {
                        font-size: 1rem;
                        a {
                            color: #000;
                            line-height: 35px;
                        }
                    }
                    #easy-access-navbar-mobile {
                        .menu-list {
                            padding-left: 0!important;
                            div {
                                line-height: 25px!important;
                                a {
                                    line-height: unset!important;
                                }
                                .item-sub-menu {
                                    a {
                                        line-height: 30px!important;
                                        display: block!important;
                                        padding: 0 0 0 15px!important;
                                    }
                                }
                            }
                        }
                    }
                }
                .bm-item-list {
                    margin-left: 0;
                }
            }

            .bm-burger-button {
                display: none!important;
                position: relative;
                left: unset !important;
                top: unset !important;

                .bm-burger-bars {
                    height: 2px;
                }
            }

        }
    }
</style>
